import React, { useState } from "react";
import headerBackgroundImage from "./header2.png";
import { IoIosArrowDown } from "react-icons/io";

import "./header.css"
import { Link } from "react-router-dom";
import { CiMenuFries } from "react-icons/ci";
import { IoClose } from "react-icons/io5";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      style={{ position: "sticky", top: "0", zIndex: "1000" }}
      className="w-full h-full "
    >
      <header
        className="relative z-10 shadow-lg bg-white"
        // style={{ backgroundImage: "url('./image/bgHeader.jpg')",backgroundPosition: "center",backgroundSize: "cover", height: "300px",  }}
      >
        <nav className="flex items-center justify-between pt-1 pb-1">
          <div className="flex items-center w-[39%] gap-1 lg:gap-3">
            <img
              src="./image/Logo.png"
              alt="Logo"
              className="ml-4 rounded-full pr-2 shadow-lg shadow-blue-950 lg:w-[55%]"
            />
            {/* <h4 className="font-semibold text-blue-900 uppercase text-md lg:text-md">Sant Nirankari Mission</h4> */}
          </div>
          <div className="hidden gap-3 md:flex items-center">
            <div className="flex gap-6">
              <Link className="" to="/">
                <a
                  className="relative text-lg w-fit block after:block after:content-[''] after:absolute after:h-[3px] after:bg-blue-900 after:w-full after:scale-x-0 after:hover:scale-x-100 after:transition after:duration-300 after:origin-center font-sans font-medium text-gray-700 no-underline hover:text-blue-900
                ver:text-white"
                  href=""
                >
                  Home
                </a>
              </Link>
              <div className="relative group">
                <a
                  className="relative text-lg w-fit inline-block after:block after:content-[''] after:absolute after:h-[3px] after:bg-blue-900 after:w-full after:scale-x-0 after:hover:scale-x-100 after:transition after:duration-300 after:origin-center font-sans  font-medium text-gray-700 no-underline hover:text-blue-900
                ver:text-white"
                  href=""
                >
                  The Mission
                  <IoIosArrowDown className="inline-block" />
                </a>
                <div className="absolute hidden py-2 mt-1 space-y-2 text-gray-700 bg-white rounded-md shadow-lg -left-6 w-60 group-hover:block">
                  <Link className="" to="/ideology">
                    <a className="block px-4 py-2 text-sm text-blue-800 hover:text-white hover:bg-blue-800 border-y hover:pl-5">
                      Ideology
                    </a>
                  </Link>
                  <Link className="" to="/lagacy">
                    <a className="block px-4 py-2 text-sm text-blue-800 hover:text-white hover:bg-blue-800 border-y hover:pl-5">
                      Lagacy
                    </a>
                  </Link>
                  <Link className="" to="/spirituality">
                    <a className="block px-4 py-2 text-sm text-blue-800 hover:text-white hover:bg-blue-800 border-y hover:pl-5">
                      Practical Sprituality
                    </a>
                  </Link>
                  {/* <Link className="" to="/mission/d"> */}
                  <Link className="" to="/Global">
                    <a className="block px-4 py-2 text-sm text-blue-800 hover:text-white hover:bg-blue-800 border-y hover:pl-5">
                      Global Mission
                    </a>
                  </Link>
                </div>
              </div>
              <div className="relative group">
                <a
                  className="relative text-lg w-fit block after:block after:content-[''] after:absolute after:h-[3px] after:bg-blue-900 after:w-full after:scale-x-0 after:hover:scale-x-100 after:transition after:duration-300 after:origin-center font-sans  font-medium text-gray-700 no-underline hover:text-blue-900
                ver:text-white"
                  href=""
                >
                  Activity <IoIosArrowDown className="inline-block" />
                </a>
                <div className="absolute hidden py-2 mt-1 space-y-2 text-gray-700 bg-white rounded-md shadow-lg -left-6 w-60 group-hover:block">
                  <Link className="" to="/LandmarkEvent">
                    <a className="block px-4 py-2 text-sm text-blue-800 hover:text-white hover:bg-blue-800 border-y hover:pl-5">
                      Landmark Event
                    </a>
                  </Link>
                  <Link className="" to="/News">
                    <a className="block px-4 py-2 text-sm text-blue-800 hover:text-white hover:bg-blue-800 border-y hover:pl-5">
                      News
                    </a>
                  </Link>
                  <Link className="" to="/Music">
                    <a className="block px-4 py-2 text-sm text-blue-800 hover:text-white hover:bg-blue-800 border-y hover:pl-5">
                      Music
                    </a>
                  </Link>
                </div>
              </div>
              <Link className="" to="/gallery">
                <a
                  className="relative text-lg w-fit block after:block after:content-[''] after:absolute after:h-[3px] after:bg-blue-900 after:w-full after:scale-x-0 after:hover:scale-x-100 after:transition after:duration-300 after:origin-center font-sans  font-medium text-gray-700 no-underline hover:text-blue-900
                ver:text-white"
                  href=""
                >
                  Gallery
                </a>
              </Link>
              <Link className="" to="/contact">
                <a
                  className="relative text-lg w-fit block after:block after:content-[''] after:absolute after:h-[3px] after:bg-blue-900 after:w-full after:scale-x-0 after:hover:scale-x-100 after:transition after:duration-300 after:origin-center font-sans  font-medium text-gray-700 no-underline hover:text-blue-900
                ver:text-white"
                  href=""
                >
                  Contact us
                </a>
              </Link>
            </div>
            <div className="hidden bg-slate-900 px-2 md:block modifyDiv">
              <ul className="flex justify-end col-span-1 gap-3 my-auto">
                <li>
                  <a
                    href="/"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 no-underline transition hover:opacity-75"
                  >
                    <span className="sr-only">Facebook</span>
                    <img
                      src="./image/icon/facebook.png"
                      alt="Logo"
                      className="w-6 h-6 rounded-full"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 no-underline transition hover:opacity-75"
                  >
                    <span className="sr-only">Instagram</span>
                    <img
                      src="./image/icon/instagram.png"
                      alt="Logo"
                      className="w-7 h-7 rounded-full"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 no-underline transition hover:opacity-75"
                  >
                    <span className="sr-only">Twitter</span>
                    <img
                      src="./image/icon/twitter.png"
                      alt="Logo"
                      className="w-6 h-6 rounded-full"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/user/SantNirankariMission"
                    rel="noreferrer"
                    target="_blank"
                    className="text-gray-200 no-underline transition hover:opacity-75"
                  >
                    <span className="sr-only">YouTube</span>
                    <img
                      src="./image/icon/youtube.png"
                      alt="Logo"
                      className="w-7 h-7 rounded-full"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="md:hidden">
            <button className="text-black" onClick={toggleMenu}>
              {isOpen ? <IoClose /> : <CiMenuFries />}
            </button>
          </div>
          <div className={`md:hidden ${isOpen ? "block" : "hidden"}`}>
            <ul className="pt-4 pb-2 text-white">
              <li>
                <a href="#">Home</a>
              </li>
              <li>
                <a href="#">The Mission</a>
              </li>
              <li>
                <a href="#">Activity</a>
              </li>
              <li>
                <a href="#">Media</a>
              </li>
              <li>
                <a href="#">Gallery</a>
              </li>
              <li>
                <a href="#">Contact Us</a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
      {/* <div className="py-1 bg-blue-800 bg-cover">
      </div> */}
    </div>
  );
};

export default Header;
